export default __webpack_public_path__ + "static/balloonium-e8e9b7b67e06f8ff3dbbbf211dc3a9b9.png";